import { render, staticRenderFns } from "./VerifactuSettings.vue?vue&type=template&id=23206c06&"
import script from "./VerifactuSettings.vue?vue&type=script&lang=js&"
export * from "./VerifactuSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports